
/*eslint-disable */

import axios from 'axios';
import carousel from 'vue-owl-carousel';
import completedInterViewList from '../../staff/interview/completed-interview-list/index.vue';
import interviewListScreen from '../interview-list-screen/index.vue';
import promotedInterViewList from '../../staff/interview/promoted-interview-list/index.vue';
import scheduledInterViewList from '../../staff/interview/scheduled-interview-list/index.vue';
import selectedInterViewList from '../../staff/interview/selected-interview-list/index.vue';
import upcomingInterViewList from '../../staff/interview/upcoming-interview-list/index.vue';

const $ = window.jQuery = require('jquery'); 

export default {
  name: 'interview-page-view',
  components: {
    carousel,
    'interview-list-screen' : interviewListScreen,
    'completed-interview-list' : completedInterViewList,
    'promoted-interview-list' : promotedInterViewList,
    'selected-interview-list' : selectedInterViewList,
    'upcoming-interview-list' : upcomingInterViewList,
    'scheduled-interview-list' : scheduledInterViewList
  },
  props: [],
  data () {
    return {
      submitted:false,
      countryList:[],
      filterOfEmployee:'',
      filterTabsChangedState:'view_interview',
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false,
      userFilterInfoData:''
    }
  },
  computed: {
  },
  mounted () { 
  },
  methods: {
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    filterTabsChangesMethod(arg){
      this.filterTabsChangedState = arg
      $('.total_count_box').removeClass('active')
      $('#filtered' + arg).addClass('active')
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.employeeListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.employeeListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    document.body.classList.remove('body_right_scroll_remove')
    next();
  },
}